export function formatNumber(value, fractionDigits = 2) {
  if (value >= 10000 && value < 100000000) return [(value / 10000).toFixed(fractionDigits), '万']
  if (value >= 100000000) return [(value / 100000000).toFixed(fractionDigits), '亿']
  return [value ?? '-', null]
}
/**
 * 转换率友好显示
 * (1) 转化率＞80%，显示「高」；
 * (2) 60%＜转化率≤80%，显示「较高」；
 * (3) 40%＜转化率≤60%，显示「中等」；
 * (4) 20%＜转化率≤40%，显示「较低」；
 * (5) 转化率≤20%，显示「低」；
 * @param {*} viewCount 浏览量
 * @param {*} saleVolume 销量
 * @returns
 */
export function conversionRate(viewCount, saleVolume) {
  if (!viewCount) return '-'
  const rate = (saleVolume || 0) / viewCount
  if (rate >= 0.8) return '高'
  if (rate > 0.6 && rate <= 0.8) return '较高'
  if (rate > 0.4 && rate <= 0.6) return '中等'
  if (rate > 0.2 && rate <= 0.4) return '较低'
  return '低'
}

// 格式化淘宝模糊数据
export function formatTaobaoVagueData(val, short = true, unit = '') {
  if (val === null || val === undefined || Number.isNaN(val)) {
    return '-'
  }
  if (val >= 5000 && val < 10000 && (val % 500) === 0) {
    return `${val}+`
  } if (val >= 10000 && val % 1000 === 0) {
    return `${short ? formatNumber(val, 1).join('') : val}${unit}+`
  }
  return (short ? formatNumber(val, 1).join('') : val) + unit
}

export const formatNumber100Add = (val) => {
  return val > 100 ? '99+' : val
}
